import { Link } from "react-router-dom";

import { Button, Headline, Small } from "@fronterahealth/frontera-ui-components";

import { SavedGoalsBank } from "@components/GoalsBank/SavedGoals/SavedGoalsBank";
import { useAdminData } from "@providers/AdminDataProvider";

interface CreditHeaderProps {
  setDialogOpen: (open: boolean) => void;
  credits: number;
  refetch: () => void;
  isSelfServeUser: boolean;
}

export const CreditHeader: React.FC<CreditHeaderProps> = ({ setDialogOpen, credits, isSelfServeUser }) => {
  const { isFetchingAssessmentCredits } = useAdminData();

  // If we're a self-serve user and still loading credits data, show loading state
  if (isSelfServeUser && isFetchingAssessmentCredits) {
    return (
      <div className="flex mt- mb-4  w-full items-center justify-between">
        <Headline size="medium">Assessment Reports</Headline>
        <SavedGoalsBank />
      </div>
    );
  }

  const showNewReportButton = credits > 0 || !isSelfServeUser;
  const showNoCreditsWarning = isSelfServeUser && credits === 0;

  return (
    <>
      <div className="flex mt-10 mb-4  w-full items-center justify-between">
        <Headline size="medium" className="inline-flex items-center">
          Assessment Reports
        </Headline>

        {showNewReportButton ? (
          <div className="flex items-center gap-2">
            <SavedGoalsBank />
            <Button text="New Report" appearance="primary" onClick={() => setDialogOpen(true)} />
          </div>
        ) : (
          <SavedGoalsBank />
        )}
      </div>
      {showNoCreditsWarning && (
        <div className="flex mt-4 items-center justify-between bg-[#ECEAE6] rounded-xl p-4">
          <div className="w-2/3">
            <Headline size="medium">No Credits</Headline>
            <Small>
              You have used all your credits. Please purchase more credits to create additional assessment reports.
            </Small>
          </div>
          <Link to="/products">
            <Button text="Buy Credits" appearance="primary" />
          </Link>
        </div>
      )}
    </>
  );
};
